import { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';

import { type Decoration } from '@api';
import { useImageIsLoaded } from '@hooks';

import { CircleTextSVG } from './CircleTextSVG';

type Props = {
  image: string;
  size?: 'small' | 'medium' | 'large';
  decoration?: Decoration;
};

const maskImages = {
  small: '/tin_preview_mask_small.png',
  medium: '/tin_preview_mask.png',
  large: '/tin_preview_mask_light_blue.png', // Assuming you have a large version
};

export const TinPreview: FC<Props> = ({
  image,
  size = 'medium',
  decoration,
}) => {
  const imageLoaded = useImageIsLoaded(image);

  return (
    <Box
      sx={{
        backgroundColor: '#0032a1',
        height: '100%',
        width: '100%',
      }}
    >
      <Box
        sx={{
          height: '100%',
          width: '100%',
          paddingBottom: '100%',
          backgroundImage: `url(${image})`,
          backgroundSize: '86%',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          position: 'relative',
        }}
      >
        {decoration && (
          <>
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <Box
                sx={{ width: '40%' }}
                component={'img'}
                src="/creme_logo.png"
              />
            </Box>
            <Box
              display={'flex'}
              position={'absolute'}
              top="8%"
              left="8%"
              width={'84%'}
              height={'84%'}
              justifyContent={'center'}
              alignItems={'center'}
              sx={{
                maskImage: 'url(/circle_mask.svg)',
              }}
            >
              {decoration && decoration.text && (
                <CircleTextSVG text={decoration.text.toUpperCase()} />
              )}

              {decoration && decoration.thumbnail && (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    position: 'absolute',
                    left: 0,
                    top: 0,
                  }}
                  component={'img'}
                  src={decoration?.thumbnail}
                />
              )}
            </Box>
          </>
        )}

        <Box
          sx={{
            backgroundImage: `url(${maskImages[size]})`,
            position: 'absolute',
            backgroundSize: 'cover',
            bacgrkoundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {!imageLoaded && <CircularProgress size={'60%'} />}
        </Box>
      </Box>
    </Box>
  );
};
